module.exports = __webpack_public_path__ + "img/watchlist-warning.56c24e78.svg";